import UserAgent from './express-useragent';

export function copyTextToClipboard(content: string) {
  const userAgent = new UserAgent().parse(navigator.userAgent);
  const isIOS = userAgent.isiPad || userAgent.isiPod || userAgent.isiPhone;
  const ta = document.createElement('textarea');
  document.body.appendChild(ta);
  ta.textContent = content;
  if (isIOS) {
    iosCopyToClipboard(ta)
  } else {
    ta.select();
  }
  document.execCommand('copy');
  document.body.removeChild(ta);
}

function iosCopyToClipboard(el) {
  var oldContentEditable = el.contentEditable,
      oldReadOnly = el.readOnly,
      range = document.createRange();

  el.contentEditable = true;
  el.readOnly = false;
  range.selectNodeContents(el);

  let s = window.getSelection();
  if (s) {
    s.removeAllRanges();
    s.addRange(range);
  }

  el.setSelectionRange(0, 999999); // A big number, to cover anything that could be inside the element.

  el.contentEditable = oldContentEditable;
  el.readOnly = oldReadOnly;
}